// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"104":"98c59f8b","274":"183175ac","752":"4d88f28f"}[chunkId] + ".chunk.css";
};